export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 0.9,
        "transcript": "Una... lartuci.",
        "translation": "This... you_pl [?]."
    },
    "2": {
        "startTime": 1.0,
        "endTime": 4.5,
        "transcript": "Au͡g'um-ll' ava-i carraquinermek cali alairrluki.",
        "translation": "And [s]he also brought up a little about it."
    },
    "3": {
        "startTime": 4.6,
        "endTime": 14.0,
        "transcript": "Tau͡gaam man'a wani topic-aangqertuq quyurtellerput ayarum qanruyutainek.",
        "translation": "But the topic of our meeting here is traditional wisdom about walking staffs."
    },
    "4": {
        "startTime": 15.5,
        "endTime": 18.9,
        "transcript": "Una waniwa piicunaunani naumalria.",
        "translation": "Everyone needs this [naturally] grown tool."
    },
    "5": {
        "startTime": 19.0,
        "endTime": 23.9,
        "transcript": "Wiinga-llu imumi tan'gaurlullraullemni pilallruatnga",
        "translation": "They also told me back when I was a boy"
    },
    "6": {
        "startTime": 24.0,
        "endTime": 27.9,
        "transcript": "Ayaruunii ayagasqevkenii yuilqumun.",
        "translation": "That I should not travel to the wilderness without a staff."
    },
    "7": {
        "startTime": 28.0,
        "endTime": 32.9,
        "transcript": "Tua-llu una tunglia maantarkaullruyaaquq tayim' ataataka",
        "translation": "And the next, my paternal uncle, was supposed to be here"
    },
    "8": {
        "startTime": 33.0,
        "endTime": 37.0,
        "transcript": "Tau͡gaam iluvanricugnarquq Elataaq.",
        "translation": "But Elataaq probably didn't come in."
    },
    "9": {
        "startTime": 43.5,
        "endTime": 47.5,
        "transcript": "Assirtut. Assilrianek qalarqu'rtut.",
        "translation": "They're good. They're talking about good things."
    },
    "10": {
        "startTime": 47.6,
        "endTime": 55.0,
        "transcript": "Man'a-llu wangkuta caliaqengarput kanaryarpiaqaqluku",
        "translation": "And they almost talk about what we work on here"
    },
    "11": {
        "startTime": 55.1,
        "endTime": 60.0,
        "transcript": "Wangkuta aprumalriani yuarteńek.",
        "translation": "We who are called search and rescue."
    },
    "12": {
        "startTime": 62.0,
        "endTime": 65.5,
        "transcript": "Tua-i wangkuta nallemteggun tamakuunricaaqukut.",
        "translation": "Concerning us [our organization], that's not what we are."
    },
    "13": {
        "startTime": 66.5,
        "endTime": 74.0,
        "transcript": "Yuk amlleq piyulria ilagaucugngauq pisteḿek atengqenrilnge'rmi.",
        "translation": "Many people who want to can join even if they don't have the title."
    },
    "14": {
        "startTime": 75.0,
        "endTime": 79.0,
        "transcript": "Tua-i ikayuayugngaitkut tamakut.",
        "translation": "They can help us."
    },
    "15": {
        "startTime": 81.5,
        "endTime": 89.5,
        "transcript": "Tua-llu ciuqliuluku wiinga quyatengqertua uumek.",
        "translation": "So, first of all, I am thankful for this."
    },
    "16": {
        "startTime": 91.0,
        "endTime": 98.0,
        "transcript": "Uksurpak imutun tua-i ciutekelriatun ayuqellruarput.",
        "translation": "It was like it was our ears all winter."
    },
    "17": {
        "startTime": 99.5,
        "endTime": 105.0,
        "transcript": "Camek tua-i qanrupailgakut camek nalluluta uitaaqluta.",
        "translation": "Before they told us anything, we wouldn't know anything."
    },
    "18": {
        "startTime": 108.5,
        "endTime": 115.0,
        "transcript": "Tua-i tuaten pingraan wiinga-llu CB-tgun niiquralaryaaqanka",
        "translation": "Despite that, I also hear about them through CB radios"
    },
    "19": {
        "startTime": 115.1,
        "endTime": 124.0,
        "transcript": "Tau͡gaam ukugnek wani camek niipailegma tamana uitat'la'rqa.",
        "translation": "But before I hear about it from these two, I leave that alone."
    },
    "20": {
        "startTime": 127.5,
        "endTime": 134.5,
        "transcript": "Imutun tua-i kevgarraulriatun ayuqlua ukugnun.",
        "translation": "I am like a helper for them_2."
    },
    "21": {
        "startTime": 136.0,
        "endTime": 145.0,
        "transcript": "Tua-i camek qanqagnek nutaan avaqlimteńun call-aqulartukuk",
        "translation": "When they_2 say something, we_2 make calls to our surrounding [villages]"
    },
    "22": {
        "startTime": 145.1,
        "endTime": 148.0,
        "transcript": "Una-llu ikayuqlunuk yuk'a-llu.",
        "translation": "[S]he, my child, and I helping each other."
    },
    "23": {
        "startTime": 151.5,
        "endTime": 158.0,
        "transcript": "Tua-i tamaa-i assirluni uum wani aulukaakut uksurpak.",
        "translation": "It's good that [s]he's taken care of us all winter."
    },
    "24": {
        "startTime": 158.7,
        "endTime": 164.0,
        "transcript": "Tuarpaiq wangkuta cakviurutkaput elliin ciullguqu'urluki",
        "translation": "It truly seems that [s]he goes ahead of our struggles"
    },
    "25": {
        "startTime": 165.9,
        "endTime": 170.0,
        "transcript": "Qanruqu'urluki nunat makumiungunrilnguut",
        "translation": "Telling the villages outside of here"
    },
    "26": {
        "startTime": 172.0,
        "endTime": 178.5,
        "transcript": "Tua-i camek maani makumiungulriamek tamariaqamta.",
        "translation": "When we lose someone from here."
    },
    "27": {
        "startTime": 179.5,
        "endTime": 183.9,
        "transcript": "Tua-i uum tau͡gaam avaqliput nallunrirceqaarluki",
        "translation": "But [s]he lets our surrounding villages know"
    },
    "28": {
        "startTime": 184.0,
        "endTime": 189.0,
        "transcript": "Piyugteqelriit aturyugarkaitnek payugtaqluki",
        "translation": "Bringing what the willing will need"
    },
    "29": {
        "startTime": 190.0,
        "endTime": 196.0,
        "transcript": "Wangkuta tarritarkani ayagaarkani pivkarpek'nata.",
        "translation": "So that we who will go do not have to."
    },
    "30": {
        "startTime": 198.0,
        "endTime": 201.0,
        "transcript": "Tua-i kevgartualuta tuarpiaq.",
        "translation": "It truly seems [s]he's like a helper."
    },
    "31": {
        "startTime": 202.5,
        "endTime": 207.0,
        "transcript": "Waten maliguqu'urluni ciungani pilallruyaaquq",
        "translation": "In the past, [s]he would always go with us"
    },
    "32": {
        "startTime": 207.9,
        "endTime": 212.5,
        "transcript": "Tau͡gaam maa-i uksurpak tuatnanrituq.",
        "translation": "But [s]he didn't do that all winter."
    },
    "33": {
        "startTime": 212.9,
        "endTime": 219.0,
        "transcript": "Tau͡gaam wangkutni calinruluni calillruuq murilkurallemni.",
        "translation": "But in my observation, [s]he worked harder than we did."
    },
    "34": {
        "startTime": 219.9,
        "endTime": 225.0,
        "transcript": "Camek nalluvkarpek'nata wangkuta aprumalriani yuarteńek.",
        "translation": "[S]he lets us who are called search and rescue know everything [she can]."
    },
    "35": {
        "startTime": 227.0,
        "endTime": 232.0,
        "transcript": "Una tua-i waniwa quyanarquq cakneq ika…",
        "translation": "I am very thankful for all of this person's help…"
    },
    "36": {
        "startTime": 236.0,
        "endTime": 239.0,
        "transcript": "…ang'aquuraasqelluku uqamaicuitniluku.",
        "translation": "…saying to pull him in, that he will be heavy."
    },
    "37": {
        "startTime": 240.5,
        "endTime": 244.0,
        "transcript": "Tua-llu malingqerkuma malika kiskan",
        "translation": "If I have a companion and [s]he falls into the water"
    },
    "38": {
        "startTime": 245.5,
        "endTime": 248.0,
        "transcript": "Tegusciigalkan, aarnaqluni tegusciigalkan",
        "translation": "If [s]he cannot be taken and is in danger"
    },
    "39": {
        "startTime": 248.5,
        "endTime": 254.0,
        "transcript": "Tamaaggun-gguq miluquluku teguyugngaaqa, teguyugngaciqaqa.",
        "translation": "They said that I can throw that at him and take him."
    },
    "40": {
        "startTime": 254.9,
        "endTime": 262.0,
        "transcript": "Cali-llu tegukumku canlilriamun call' ayaulluku",
        "translation": "Also, when I take him, I should also bring him to a grassy area"
    },
    "41": {
        "startTime": 262.5,
        "endTime": 272.0,
        "transcript": "Aturai yuuluki canegnek cali ciurraarluki ac'etaqluki, canegnek ekiiraqluki.",
        "translation": "Take off his clothes, wring them, [put] grass [inside] and put them on him, insulating them with grass."
    },
    "42": {
        "startTime": 272.4,
        "endTime": 275.0,
        "transcript": "Can'get-gguq makut maqartut.",
        "translation": "They say that grass is warm."
    },
    "43": {
        "startTime": 276.0,
        "endTime": 278.5,
        "transcript": "Maqarniluki qanrutketullrui.",
        "translation": "[S]he used to say that they're warm."
    },
    "44": {
        "startTime": 279.5,
        "endTime": 284.5,
        "transcript": "Taumek waniw' uksuaq imumi kiani misviim kiatiini",
        "translation": "That's why last fall, upriver from the airport"
    },
    "45": {
        "startTime": 285.5,
        "endTime": 293.5,
        "transcript": "Nugtelaryaaqellrulliniat imna kit'elleq imna, Arthur-aam im' yua.",
        "translation": "They used to bring Arthur's child out of the water who had fallen in."
    },
    "46": {
        "startTime": 293.9,
        "endTime": 297.0,
        "transcript": "Tau͡gaam ataam kit'aqluni nugesciiganani.",
        "translation": "But he would sink again, unable to come out of the water."
    },
    "47": {
        "startTime": 298.5,
        "endTime": 304.0,
        "transcript": "Ilavkungqerkunek teguyugngaqapiaryaaqelliniluku qanemcilqengagka qanemcillermegni.",
        "translation": "They would have been able to take him had they had some rope from what the ones2 who told me the story said."
    },
    "48": {
        "startTime": 305.9,
        "endTime": 309.0,
        "transcript": "Tamana wii eneqaqallruaqa qanruyutek'lalqa.",
        "translation": "I remembered that traditional wisdom that was told to me."
    },
    "49": {
        "startTime": 312.0,
        "endTime": 316.0,
        "transcript": "Amllerrsaaqut ayuqucirtuuteput, ayuqucirtuutek'lalput.",
        "translation": "We have a lot of lessons, lessons that we heard."
    },
    "50": {
        "startTime": 316.1,
        "endTime": 322.5,
        "transcript": "Wangkuta-w' tua-i ayagyuani apa'urlungqellriani apa'urlumta qanruyutek'lallrit.",
        "translation": "We young people who have grandfathers, our grandfather's traditional wisdom."
    },
    "51": {
        "startTime": 322.6,
        "endTime": 331.0,
        "transcript": "Cali tuamtellu nunat elatiitnun elliqumta uksuarmi waten pitullruanga:",
        "translation": "Also, if we come to the outskirts of a village in the fall, he would say to me:"
    },
    "52": {
        "startTime": 331.1,
        "endTime": 336.0,
        "transcript": "Nunat-gguq elatiitnun elliquma qertulriamek tangerquma",
        "translation": "If I come to the outskirts of a village and see an elevated place"
    },
    "53": {
        "startTime": 337.0,
        "endTime": 341.0,
        "transcript": "Ullagluku qainganun mayurlua avateka kiareskilaku",
        "translation": "I should go to it, climb, and look around me"
    },
    "54": {
        "startTime": 341.1,
        "endTime": 347.5,
        "transcript": "Nunat avatiit kiareskilaku nallunairturluki ukut nunat.",
        "translation": "I should look around the village to notify them [of my presence]."
    },
    "55": {
        "startTime": 349.0,
        "endTime": 359.5,
        "transcript": "Una tua-i qertulria, makut-llu qertuuralriit, nanvat-llu makut qertuuralriarit ceńaitni murilkelluki cakneq.",
        "translation": "I should thoroughly observe this elevated area, and these [other] elevated areas, and the lakes around them."
    },
    "56": {
        "startTime": 360.0,
        "endTime": 366.0,
        "transcript": "Tamaa-i-gguq anirtuutekaqanka ellam, ella assiireskan nalluyagutailkuma.",
        "translation": "They said that they will save me if the weather turns bad and I do not forget them."
    },
    "57": {
        "startTime": 367.0,
        "endTime": 370.5,
        "transcript": "Tau͡gaam tua-i wiinga atuqsaitellruanka tamakut.",
        "translation": "But I've never done that."
    },
    "58": {
        "startTime": 372.5,
        "endTime": 375.5,
        "transcript": "Nalluyaguqurluki-w' tua-i pilallruamki imumi.",
        "translation": "It's because I forgot them back then."
    },
    "59": {
        "startTime": 376.0,
        "endTime": 379.0,
        "transcript": "Iliini tau͡gaam tua-i nallunritaqluki.",
        "translation": "Sometimes, though, I knew them."
    },
    "60": {
        "startTime": 379.9,
        "endTime": 381.5,
        "transcript": "Tuamtellu pinauraanga:",
        "translation": "And then [s]he would say to me:"
    },
    "61": {
        "startTime": 381.6,
        "endTime": 388.0,
        "transcript": "Cacetulria-gguq arenqiallugtellerkaminun tau͡gaam tekitaatuuq",
        "translation": "A self-confident person only comes upon misfortune"
    },
    "62": {
        "startTime": 390.0,
        "endTime": 392.5,
        "transcript": "Apqiitnek cacetulria.",
        "translation": "Someone they call cacetulria."
    },
    "63": {
        "startTime": 393.7,
        "endTime": 403.0,
        "transcript": "Tau͡gken-gguq imna caceskilnguq tua-i arenqiallugpakayuunani.",
        "translation": "However, [s]he said that someone who isn't self-confident does not come upon too much misfortune."
    },
    "64": {
        "startTime": 404.0,
        "endTime": 410.0,
        "transcript": "Ilumun tua-i tamana wiinga atullruaqa.",
        "translation": "Indeed, I have experienced that."
    },
    "65": {
        "startTime": 411.0,
        "endTime": 416.0,
        "transcript": "Alingtaama tua-i waniw' arenqiallugpailegma waten ellirtua.",
        "translation": "Because I'm scared by nature, I've become this old before coming upon any misfortune."
    },
    "66": {
        "startTime": 417.0,
        "endTime": 424.0,
        "transcript": "Ataucirquqapiarmek tau͡gaam waten uksumi mat'um maa-i nalliini",
        "translation": "Only a single time in the winter around this time"
    },
    "67": {
        "startTime": 425.5,
        "endTime": 430.5,
        "transcript": "Ugna-llu Alba-llu maliklunuk maavirqaarlunuk utertellmegni",
        "translation": "When Alba downriver and I went returned together after coming here"
    },
    "68": {
        "startTime": 431.5,
        "endTime": 438.0,
        "transcript": "Qavartarvigmun uaken Kuigilngurmiut canimellekluki qavartaucugyaaqekiinga.",
        "translation": "[S]he wanted me to camp close to Kwigillingok downriver."
    },
    "69": {
        "startTime": 438.1,
        "endTime": 444.0,
        "transcript": "Piaqa wii atrarciqnilua, nunat canimetniluki.",
        "translation": "I told him that I would go down, that the village was close."
    },
    "70": {
        "startTime": 444.9,
        "endTime": 449.0,
        "transcript": "Tua-i nunat waniw' tekiteqerluki uunguciircama",
        "translation": "Because I became confused just as we reached the village"
    },
    "71": {
        "startTime": 449.9,
        "endTime": 455.0,
        "transcript": "Au͡gna-llu malika arulairlunuk piaqa,",
        "translation": "My companion and I stopped and I said to him,"
    },
    "72": {
        "startTime": 455.5,
        "endTime": 458.5,
        "transcript": "“Ayagiinarpek'nanuk arulairnaurtukuk”",
        "translation": "“We should stop without continuing further”"
    },
    "73": {
        "startTime": 458.6,
        "endTime": 460.0,
        "transcript": "Pircian-llu-w' qakemna ella.",
        "translation": "Because there was a blizzard blowing outside."
    },
    "74": {
        "startTime": 461.5,
        "endTime": 467.0,
        "transcript": "Cunaw' wavet nunat keluaraatnun arulallinilriakuk.",
        "translation": "Apparently, we had stopped right inland from the village."
    },
    "75": {
        "startTime": 467.5,
        "endTime": 475.0,
        "transcript": "Unuakumi maaten tanqigiaraan qinertua elitnaurvik una ciuqerramni, ciuqamni.",
        "translation": "In the morning, I looked out when it was getting bright to find a school in front of me."
    },
    "76": {
        "startTime": 479.0,
        "endTime": 485.0,
        "transcript": "Au͡gkut ava-i quyanarqut au͡g'um ciuqlima uum qanrutkurallri.",
        "translation": "I'm thankful for what the person before me talked about."
    },
    "77": {
        "startTime": 485.5,
        "endTime": 488.5,
        "transcript": "Tua-i amllernek ilasciigatanka.",
        "translation": "I can't add a lot to them."
    },
    "78": {
        "startTime": 499.5,
        "endTime": 509.5,
        "transcript": "Quyaunga-ll' wii wani ciuqerpeceńi-wa nangengqanritnayukellruyaaqua.",
        "translation": "I'm also thankful because I had thought that I wouldn't be standing here before youpl."
    },
    "79": {
        "startTime": 510.5,
        "endTime": 517.0,
        "transcript": "Alapen'errlua-am waniw' nangertua ciuqerpeceńun quyalua.",
        "translation": "I'm surprised and thankful that I'm now standing before you¬pl."
    },
    "80": {
        "startTime": 521.0,
        "endTime": 522.9,
        "transcript": "Allamek-wa qanerkailngua",
        "translation": "I have nothing else to say"
    },
    "81": {
        "startTime": 523.5,
        "endTime": 532.0,
        "transcript": "Uumek tau͡gaam au͡g'um uum qanrutkellratun quyanarquq.",
        "translation": "Except that I'm thankful as he said."
    },
    "82": {
        "startTime": 533.0,
        "endTime": 541.0,
        "transcript": "Maantenrillruyaaqua-llu allragni Naparyarrarnun anelrarlua",
        "translation": "I had moved from here last year, going downriver to Napakiak"
    },
    "83": {
        "startTime": 541.5,
        "endTime": 550.0,
        "transcript": "Tau͡gaam niitaqama-w' tua-i uitasciigat'lartua.",
        "translation": "But when I hear about anything, I can't stay still."
    },
    "84": {
        "startTime": 552.5,
        "endTime": 559.0,
        "transcript": "CB-tgun qayagauranritesciigataqlua.",
        "translation": "I always have to call with the CB radios."
    },
    "85": {
        "startTime": 564.0,
        "endTime": 569.0,
        "transcript": "Ikayungcallerkaanek cali uum niicugniaqlua.",
        "translation": "I also listen for him to request help."
    },
    "86": {
        "startTime": 571.5,
        "endTime": 579.0,
        "transcript": "Cakmani-llu uksurpak malruulunuk-wa eguaqulartukuk",
        "translation": "And downriver, two of us encourage others"
    },
    "87": {
        "startTime": 580.0,
        "endTime": 585.0,
        "transcript": "Ugkut eguaqurluki-w' tua-i ilapuk.",
        "translation": "Encouraging our2 fellows downriver."
    },
    "88": {
        "startTime": 587.5,
        "endTime": 592.0,
        "transcript": "Quyanaqluni una maligcugnarqelartuq.",
        "translation": "I'm thankful that he inspires us to follow."
    },
    "89": {
        "startTime": 593.8,
        "endTime": 596.0,
        "transcript": "Qayagauraqan-wa tau͡gaam…",
        "translation": "But when he calls…"
    },
    "90": {
        "startTime": 601.5,
        "endTime": 606.0,
        "transcript": "Ciuqlikegciukut Fred-amek, uumek-llu cali aip…",
        "translation": "Fred is a good leader to us, along with this…"
    },
    "91": {
        "startTime": 606.5,
        "endTime": 608.5,
        "transcript": "…tua-i-w' taumek qimugciuryaramek.",
        "translation": "…about mushing dogs."
    },
    "92": {
        "startTime": 609.5,
        "endTime": 617.0,
        "transcript": "Tau͡gaam makut angutet ak'allaaraat-ll' nallunrillruyaaqaat wangkugni.",
        "translation": "But these men and the older ones know more than we2 do."
    },
    "93": {
        "startTime": 617.5,
        "endTime": 621.0,
        "transcript": "Tau͡gaam wangkuk tua-i pisqumiitkuk",
        "translation": "But because they've asked us2 to"
    },
    "94": {
        "startTime": 621.1,
        "endTime": 629.0,
        "transcript": "Tamatumek qimugteḿek, qimugciuryaramek wani watua pisqutacimegcetun qanqatartukuk.",
        "translation": "We're2 going to talk about dogs, dog mushing, as we2 were asked to do."
    },
    "95": {
        "startTime": 629.5,
        "endTime": 636.0,
        "transcript": "Imkut tang wiinga angullrenka yullret qimugteliqullrunritellrulriit.",
        "translation": "You see, the people I was born in time to see back then didn't have a lot of dogs."
    },
    "96": {
        "startTime": 637.5,
        "endTime": 644.0,
        "transcript": "Cali-llu tallimanek una tua-i qimugtelilria qimugtengqerrngatetullruuq wii tangvallemni.",
        "translation": "Also, it seemed that someone who had a lot of dogs seemed to have five from what I've seen."
    },
    "97": {
        "startTime": 645.0,
        "endTime": 652.0,
        "transcript": "Cali-llu qimugtet tamakut yup'igtun aulukluki kenekluki.",
        "translation": "They also took care of and loved those dogs like real people."
    },
    "98": {
        "startTime": 652.5,
        "endTime": 658.0,
        "transcript": "Ilaita-llu elaturrami petuumalkircuilngatellruluteng-llu.",
        "translation": "And some of them didn't seem to be leashed at all in the porch."
    },
    "99": {
        "startTime": 658.5,
        "endTime": 662.0,
        "transcript": "Elaturrami qungelranaurtut ilakuyulluteng.",
        "translation": "They would huddle in the porch all together."
    },
    "100": {
        "startTime": 663.5,
        "endTime": 667.5,
        "transcript": "Qaillun uirrsuitellruut-llu-qaa tamakut?",
        "translation": "Didn't they ever even fight?"
    },
    "101": {
        "startTime": 668.5,
        "endTime": 675.0,
        "transcript": "Tuamtellu waten pinarian imkut yullret qanemciaqameng qanernaurtut",
        "translation": "And then when it was time like this, the people back then would tell stories"
    },
    "102": {
        "startTime": 676.0,
        "endTime": 681.0,
        "transcript": "Ak'a-gguq qimugtengqetullruut kasmurluteng piaqameng",
        "translation": "They say that a long time ago, they had dogs that when they pushed sleds"
    },
    "103": {
        "startTime": 681.5,
        "endTime": 683.5,
        "transcript": "Taqumun wavet petuglukek.",
        "translation": "They would leash them2 to the side here."
    },
    "104": {
        "startTime": 684.0,
        "endTime": 689.5,
        "transcript": "Ikayuqu'urlukek tua-i tamakut qimugtet atutullruit.",
        "translation": "They got help from their dogs as they utilized them."
    },
    "105": {
        "startTime": 690.0,
        "endTime": 693.5,
        "transcript": "Ak'a tamaani ciuqvani ikayuqengnaqluki.",
        "translation": "Back a long time ago, they tried to have them help."
    },
    "106": {
        "startTime": 694.5,
        "endTime": 700.0,
        "transcript": "Cali-llu makut ciulirneput qantullruut waten, qimugciryaurcama-llu:",
        "translation": "And our elders would say this, also when I started mushing dogs:"
    },
    "107": {
        "startTime": 701.8,
        "endTime": 706.0,
        "transcript": "Qimugtem-gguq kiimi aqsaquni qimugteńgutekaa.",
        "translation": "Only its stomach makes a dog a mushing dog."
    },
    "108": {
        "startTime": 706.5,
        "endTime": 709.5,
        "transcript": "Ilumuuyugnarquq tua-i tauna.",
        "translation": "That is probably true."
    },
    "109": {
        "startTime": 710.0,
        "endTime": 713.5,
        "transcript": "Qimugtem-gguq kiimi iluni qimugteńgutekaa",
        "translation": "Only its stomach makes a dog a mushing dog"
    },
    "110": {
        "startTime": 714.5,
        "endTime": 717.0,
        "transcript": "Kemengqerrutekngamteggu tamamta.",
        "translation": "Because it strengthens the flesh for all of us."
    },
    "111": {
        "startTime": 717.5,
        "endTime": 721.5,
        "transcript": "Wangkuta-llu tamana cali nalluvkenaku Yup'igni",
        "translation": "We Yupiit also know that"
    },
    "112": {
        "startTime": 722.5,
        "endTime": 729.0,
        "transcript": "Anrutarput imaitaqan angniyuitukut, quuyurnilleq-llu una ikgenani.",
        "translation": "When our stomachs are empty, we're not happy, and smile so little."
    },
    "113": {
        "startTime": 730.0,
        "endTime": 734.0,
        "transcript": "Cali-llu makut qimugtet ak'a niitelallrukenka",
        "translation": "I also used hear about dogs a long time ago"
    },
    "114": {
        "startTime": 734.5,
        "endTime": 740.5,
        "transcript": "Ingna-gguq ciulistekegciqapiartuq maligngaluni-llu.",
        "translation": "That that one over there has a great leader and is obedient."
    },
    "115": {
        "startTime": 741.5,
        "endTime": 749.0,
        "transcript": "Tuaten-llu tamakut qimugtet ilait wiinga niitaqamki qanlartut",
        "translation": "And when I hear about some dogs like that, they would say"
    },
    "116": {
        "startTime": 749.5,
        "endTime": 752.5,
        "transcript": "Ciulistii-gguq atam im'um usvitupiartuq.",
        "translation": "That that person's lead dog is very smart."
    },
    "117": {
        "startTime": 753.0,
        "endTime": 758.5,
        "transcript": "Cangraan, pircingraan ciunranun tuavet piyullranun tekiutetua.",
        "translation": "No matter what, even in a blizzard, it brings its owner where he wants."
    },
    "118": {
        "startTime": 759.0,
        "endTime": 760.6,
        "transcript": "Ilumuuguq-qaa tamana?",
        "translation": "Is that true?"
    },
    "119": {
        "startTime": 761.5,
        "endTime": 764.0,
        "transcript": "Ii-i, tua-i taungulliniuq.",
        "translation": "Yes, that's what it is."
    },
    "120": {
        "startTime": 765.5,
        "endTime": 771.0,
        "transcript": "Cali-llu wangtun umyuangqerrsukluki qimugtet umyuarteqellruunga.",
        "translation": "I also thought that dogs had minds like me."
    },
    "121": {
        "startTime": 772.0,
        "endTime": 781.0,
        "transcript": "Wiinga asgurtau͡rluama qimugtem ikayullrani quyaqapiarallruunga taumek qimugteḿek.",
        "translation": "Because I'm doubtful, when the dog helped, I was very thankful for that dog."
    },
    "122": {
        "startTime": 782.0,
        "endTime": 784.0,
        "transcript": "Tangrriu imumirpak ak'ar[pak]…",
        "translation": "Look, since a long time ago…"
    },
    "123": {
        "startTime": 785.0,
        "endTime": 792.5,
        "transcript": "…tan'gurra'urluulua pissuryarlua ayaglua yungqellruan tauna pissuryararraq",
        "translation": "…as a boy, I traveled to go hunt because there were people in the hunting ground there"
    },
    "124": {
        "startTime": 793.5,
        "endTime": 795.5,
        "transcript": "Enenguluni-ll' kiimi.",
        "translation": "And it was the only house."
    },
    "125": {
        "startTime": 795.6,
        "endTime": 802.0,
        "transcript": "Tua-i qutegglua ilangqerciqngama alingtaama-llu ayagyaaqua.",
        "translation": "I was overconfident because I would have companions when I went and I was scared by nature."
    },
    "126": {
        "startTime": 802.1,
        "endTime": 808.0,
        "transcript": "Tekitua maaten taumun enemun waniw' ciungaramni ayallrullinilriit.",
        "translation": "I arrived at the house to find that they had gone just ahead of me."
    },
    "127": {
        "startTime": 808.5,
        "endTime": 812.0,
        "transcript": "Imkut nunamiutarnek nerengnaquratullemteńi",
        "translation": "Back when we only survived by eating food from the land"
    },
    "128": {
        "startTime": 812.5,
        "endTime": 819.5,
        "transcript": "Imarmiutarnek-llu pissungnaquratullrulriakut imumi waten, waten qakemna ella elli'irtaqan.",
        "translation": "We would also hunt for minks back then when the weather outside became like this."
    },
    "129": {
        "startTime": 820.0,
        "endTime": 822.0,
        "transcript": "Tua-i uitatkevkenaki.",
        "translation": "We weren't sedentary because of them."
    },
    "130": {
        "startTime": 822.5,
        "endTime": 829.0,
        "transcript": "Qavairatekluki-llu tamakut tua-i pitengnaquralallruukut waten up'nerkami.",
        "translation": "We also lost sleep to try to catch those in the spring like this."
    },
    "131": {
        "startTime": 830.0,
        "endTime": 833.0,
        "transcript": "Tekicama tua-i umyuarteqkilii tuavet,",
        "translation": "When I got there, I thought,"
    },
    "132": {
        "startTime": 834.5,
        "endTime": 837.0,
        "transcript": "“Tua-i cam piyukunia pikilia.”",
        "translation": "“Let anything that wants to harm me do it.”"
    },
    "133": {
        "startTime": 837.3,
        "endTime": 839.0,
        "transcript": "Wangnek qevtua.",
        "translation": "I forsook myself."
    },
    "134": {
        "startTime": 839.1,
        "endTime": 841.0,
        "transcript": "Tua-i cam piyukunia pikilia.",
        "translation": "Let anything that wants to harm me do it."
    },
    "135": {
        "startTime": 841.5,
        "endTime": 848.0,
        "transcript": "Aren, alingessiyaagpakaama ciulisteka tauna iterrluku ilakluku.",
        "translation": "Oh my, because I was so scared, I brought my lead dog inside to accompany me."
    },
    "136": {
        "startTime": 849.0,
        "endTime": 852.0,
        "transcript": "Ilakluku tua-i tamaani tua-i alingyailkutekluku.",
        "translation": "It was my companion to keep me from being scared."
    },
    "137": {
        "startTime": 852.1,
        "endTime": 855.0,
        "transcript": "Kiingan tua-i cacetuqutekluku.",
        "translation": "It was the only thing to boost my morale."
    },
    "138": {
        "startTime": 856.5,
        "endTime": 863.0,
        "transcript": "Uitainanemni inarrlua aqsiqercama, qimugteka-w' kan'a ketemni palungqauralria.",
        "translation": "As I was laying down when I was full, my dog was laying face down down in front of me."
    },
    "139": {
        "startTime": 864.5,
        "endTime": 866.5,
        "transcript": "Qaill' man'a unuk ellirteqerluku",
        "translation": "At some point of this night"
    },
    "140": {
        "startTime": 866.6,
        "endTime": 872.9,
        "transcript": "Kenurrangqelallruukut imumi uqumek, kumarutengqerraqluni",
        "translation": "We used to have oil lamps back then that had wicks"
    },
    "141": {
        "startTime": 873.0,
        "endTime": 875.5,
        "transcript": "Ilait pingayunek, ilait-llu cetamanek.",
        "translation": "Some with three, and some with four."
    },
    "142": {
        "startTime": 875.6,
        "endTime": 878.0,
        "transcript": "Tanqikapiarngatnaurtuq.",
        "translation": "It would seem very bright."
    },
    "143": {
        "startTime": 878.5,
        "endTime": 880.5,
        "transcript": "Tauna tua-i kenurraq uquq.",
        "translation": "That was an oil lamp."
    },
    "144": {
        "startTime": 881.0,
        "endTime": 883.5,
        "transcript": "Tanqikapiarngatnaurtuq wangni.",
        "translation": "It would seem very bright to me."
    },
    "145": {
        "startTime": 884.5,
        "endTime": 887.0,
        "transcript": "Arenqiatuq-am ircaquqa alingmek imangqertuq.",
        "translation": "My goodness, my heart was filled with fear."
    },
    "146": {
        "startTime": 887.5,
        "endTime": 892.0,
        "transcript": "Tua-i tauna qimugta tua-i waniw' tegguteku'urluku qanertua,",
        "translation": "With the dog as my source of confidence, I said,"
    },
    "147": {
        "startTime": 893.0,
        "endTime": 899.0,
        "transcript": "“Wangkucicetun, wangkutni-ll' umyuartunruyugnarqut makut qimugtet.”",
        "translation": "“Like us, but these dogs are probably smarter than we are.”"
    },
    "148": {
        "startTime": 900.0,
        "endTime": 903.0,
        "transcript": "Uitainanemni maaten imna qimugteka piaqa",
        "translation": "As I was there, I noticed that my dog"
    },
    "149": {
        "startTime": 903.1,
        "endTime": 906.0,
        "transcript": "Ak'a amiik ugna iriatengllinikii.",
        "translation": "Had already started rocking the door back and forth."
    },
    "150": {
        "startTime": 906.1,
        "endTime": 909.0,
        "transcript": "Tua-i aren camek pingatqapiggluni.",
        "translation": "My goodness, it truly seemed that it was interacting with something."
    },
    "151": {
        "startTime": 909.5,
        "endTime": 915.0,
        "transcript": "Umyuartequa, “Qayumi tua-i piqataraanga waniw' tua-i.”",
        "translation": "I thought, “As expected, something is going to happen to me now.”"
    },
    "152": {
        "startTime": 916.0,
        "endTime": 918.0,
        "transcript": "Aren tua-i uitalua.",
        "translation": "My goodness, I stayed still."
    },
    "153": {
        "startTime": 918.1,
        "endTime": 925.0,
        "transcript": "Uitainanemni atam iternerngalngurmun qaterrluni itraaralria.",
        "translation": "As I was there, you see, something that look like a white cold draft was slowly coming inside."
    },
    "154": {
        "startTime": 926.0,
        "endTime": 930.0,
        "transcript": "Qaillun-llu pitariqerluni tayim' amuluni anluni.",
        "translation": "And when it had come in a certain distance, it contracted and went out."
    },
    "155": {
        "startTime": 930.5,
        "endTime": 935.0,
        "transcript": "Umyuarteqa'artua, “Uumiku pikanirluni piciquq.”",
        "translation": "I suddenly thought, “The next time, it'll go further.”"
    },
    "156": {
        "startTime": 935.5,
        "endTime": 939.0,
        "transcript": "Qimugteka-ll' una maani tarrangarrluni.",
        "translation": "And my dog started becoming walking about here."
    },
    "157": {
        "startTime": 939.5,
        "endTime": 944.5,
        "transcript": "Tua-i nallunaunani wangtun alingluni. Alingluni tua-i.",
        "translation": "It was obviously scared like me. It was scared."
    },
    "158": {
        "startTime": 945.5,
        "endTime": 949.0,
        "transcript": "Uumikuani piqerlua piunga nutaan arcarikanirluni",
        "translation": "The next time, I saw that it was getting worse"
    },
    "159": {
        "startTime": 949.5,
        "endTime": 953.0,
        "transcript": "Qengarmiaraluni tuaten, qilugyarpiaraqluni.",
        "translation": "Even waving its nose, almost barking."
    },
    "160": {
        "startTime": 954.5,
        "endTime": 958.5,
        "transcript": "Pinga'arteqerluni atam iterneq man'a itralria.",
        "translation": "Eventually, you see, the draft was coming inside."
    },
    "161": {
        "startTime": 959.5,
        "endTime": 961.0,
        "transcript": "Ak'akirraq tua qukaqerluku.",
        "translation": "It came in quite a bit reaching the middle."
    },
    "162": {
        "startTime": 961.1,
        "endTime": 968.5,
        "transcript": "Nutaan atam nucuan qimugteka imna tunumnun pamavet tagluni.",
        "translation": "When it extracted, my dog dog went up behind me."
    },
    "163": {
        "startTime": 969.5,
        "endTime": 976.0,
        "transcript": "Pama-i qemirrlumni sugg'eni pulalluku pamavet uitaqertuq.",
        "translation": "It put its snout into my spine behind me and stayed."
    },
    "164": {
        "startTime": 977.0,
        "endTime": 983.0,
        "transcript": "Tamana iterneq uatmurquraan, tamana tua-i anngan",
        "translation": "When that draft went toward the door, when it went out"
    },
    "165": {
        "startTime": 983.5,
        "endTime": 989.0,
        "transcript": "Qimugtema tang pam'um sugg'erminek cinguuqiliu tunuka.",
        "translation": "My dog behind me pushed my back with its snout."
    },
    "166": {
        "startTime": 989.5,
        "endTime": 995.0,
        "transcript": "Umyuarteqa'artua, “Uum tang anesqessugnarqekiinga.”",
        "translation": "I thought, “This [dog] is probably asking me to go out.”"
    },
    "167": {
        "startTime": 995.9,
        "endTime": 1000.0,
        "transcript": "Aren uitangnaqa'arcaaqellemnek",
        "translation": "My goodness, after I had tried to stay"
    },
    "168": {
        "startTime": 1001.0,
        "endTime": 1004.5,
        "transcript": "Inarrvicualleraagka atkucualle'rqa-ll' as'arrluku",
        "translation": "My sleeping mat, and after I put on my parka"
    },
    "169": {
        "startTime": 1005.5,
        "endTime": 1013.0,
        "transcript": "Taukuk tua-i inarrvicualler imkarluku nemkarluku, nacaqerlua-llu anlua.",
        "translation": "I rolled up and bound my sleeping mat, put on my hood, and went out."
    },
    "170": {
        "startTime": 1013.5,
        "endTime": 1022.0,
        "transcript": "Qakug[caq] uavet, una iteryaraq uaqliq lumarrallermek agalriartangqertuq.",
        "translation": "[Qakugcaq] toward the door, there was a cloth hanging out by the entrance."
    },
    "171": {
        "startTime": 1022.5,
        "endTime": 1026.0,
        "transcript": "Qakmavet tau͡gken anyaraq amiipiuluni.",
        "translation": "The exit going outside, however, was a real door."
    },
    "172": {
        "startTime": 1026.7,
        "endTime": 1031.0,
        "transcript": "Tauna tua-i waniw' anqataama, nacaqaama",
        "translation": "When I was going to go out, when I put on my hood"
    },
    "173": {
        "startTime": 1032.0,
        "endTime": 1035.0,
        "transcript": "Kenurrak taukuk cupqaqenka tua-i uivetmun.",
        "translation": "I blew out those2 lamps2 in a circle."
    },
    "174": {
        "startTime": 1035.5,
        "endTime": 1036.5,
        "transcript": "Nipluki tua-i.",
        "translation": "I turned them off."
    },
    "175": {
        "startTime": 1037.0,
        "endTime": 1040.9,
        "transcript": "Aren tua-i amik cuqluku anelrarlua.",
        "translation": "My goodness, I estimated [the size of] the door going out."
    },
    "176": {
        "startTime": 1041.0,
        "endTime": 1047.0,
        "transcript": "Tauna tekicamku lumarralleq qakugcamun imumun puukarlii alikek'ngamnek.",
        "translation": "When I reached that cloth, I was afraid that I would run into the [qakugcaq]."
    },
    "177": {
        "startTime": 1049.7,
        "endTime": 1054.0,
        "transcript": "Aren pivailemku ankilii ellamun.",
        "translation": "My goodness, before I did, I went out."
    },
    "178": {
        "startTime": 1055.0,
        "endTime": 1060.5,
        "transcript": "Anngama ellamun ukalirnetmun, iqlutun-llu tua-i pillruyaaqellrianga",
        "translation": "When I went out, this way, and I probably did it the wrong way"
    },
    "179": {
        "startTime": 1061.6,
        "endTime": 1067.0,
        "transcript": "Akertem ayagyaraa maliggluku uivesqelarngallruitki.",
        "translation": "I think people told them to go around clockwise."
    },
    "180": {
        "startTime": 1067.9,
        "endTime": 1073.0,
        "transcript": "Kiarteksaunii-ll' tua-i, kiingan tau͡gaam acika paallallerkaqa tau͡gaam.",
        "translation": "And I didn't look around, only beneath me in case I tripped."
    },
    "181": {
        "startTime": 1074.5,
        "endTime": 1077.5,
        "transcript": "Kassuamku tua-i avateka-ll' man'a tangeqsaunaku.",
        "translation": "When I went around it, I never saw the area around me."
    },
    "182": {
        "startTime": 1078.0,
        "endTime": 1082.0,
        "transcript": "Qimugta tauna tua-i sagtanka pingayurraungata qimugtenka.",
        "translation": "I spread out my dogs because I only had three."
    },
    "183": {
        "startTime": 1082.9,
        "endTime": 1090.0,
        "transcript": "Saagarcamki ciulisteka im' taikili tuavet tua-i ciulistem neksaraanun.",
        "translation": "When I spread them out, my lead dog came and went where the lead dog would go."
    },
    "184": {
        "startTime": 1090.5,
        "endTime": 1093.0,
        "transcript": "Qamiqurra tang uskuragnek ac'amku",
        "translation": "When I put the harnesses2 on its head"
    },
    "185": {
        "startTime": 1093.5,
        "endTime": 1100.5,
        "transcript": "Ellminek tang una picetaarpek'nani imkuk ukuk askilikek elavluni-llu.",
        "translation": "It put these2 on by itself without being told to and crouched."
    },
    "186": {
        "startTime": 1101.5,
        "endTime": 1105.5,
        "transcript": "Tuamtell' taukuk tua-i uskurarraarlukek tua-i kiarteksaunii",
        "translation": "And then after they2 were harnessed, I didn't look around"
    },
    "187": {
        "startTime": 1105.6,
        "endTime": 1109.5,
        "transcript": "Una tau͡gaam tua-i tangvalqa kiingan tangvagluku.",
        "translation": "Only watching what was in front of me."
    },
    "188": {
        "startTime": 1110.7,
        "endTime": 1114.0,
        "transcript": "Aren imkut tua-i qaqicamki haitaaqerluki.",
        "translation": "My goodness, I mushed them when I finished [preparing] them."
    },
    "189": {
        "startTime": 1115.0,
        "endTime": 1118.9,
        "transcript": "Tuar tang snowgo ayanga'rtua ugaani [cukam].",
        "translation": "I started going like a snowgo because [it was so fast]."
    },
    "190": {
        "startTime": 1119.0,
        "endTime": 1125.0,
        "transcript": "Aren alingqapiar[lua] [qakugcam] pamaken tegulia.",
        "translation": "My goodness, I was so scared that the [qakugcaq] would take me from behind."
    },
    "191": {
        "startTime": 1127.0,
        "endTime": 1130.5,
        "transcript": "Tua-i tang qimugtemnek taumek irr'illruunga.",
        "translation": "I was amazed at my dog."
    },
    "192": {
        "startTime": 1131.5,
        "endTime": 1134.0,
        "transcript": "Ikayuqapiarallrukiinga tuani tua-i.",
        "translation": "It was of great help to me then."
    },
    "193": {
        "startTime": 1134.5,
        "endTime": 1138.0,
        "transcript": "Anesqellua tua-i nallunailngurmek cinguurlua.",
        "translation": "It pushed me, obviously wanting me to go out."
    },
    "194": {
        "startTime": 1139.0,
        "endTime": 1146.5,
        "transcript": "Tua-i elpeci tayim' angutni qimugciryaram ayuqucia nallunritarci.",
        "translation": "You men know what dog mushing is like."
    },
    "195": {
        "startTime": 1147.5,
        "endTime": 1149.5,
        "transcript": "Waniw' niitelallruunga imumirpak",
        "translation": "I've always heard"
    },
    "196": {
        "startTime": 1150.0,
        "endTime": 1155.5,
        "transcript": "Qimugtem-gguq kiimi aqsaquni qimuteńgutekaa.",
        "translation": "That its stomach is what makes a dog a mushing dog."
    },
    "197": {
        "startTime": 1156.0,
        "endTime": 1165.0,
        "transcript": "Cali-llu waten qimugtet irnitulriit, tua-i-llu anglicarluki kenekluki.",
        "translation": "Also, these dogs that have litters raise and love them."
    },
    "198": {
        "startTime": 1165.8,
        "endTime": 1171.5,
        "transcript": "Tua-i-llu pinariata aturluki qimugyaraq elitnaurcelluku.",
        "translation": "And then when it's time we utilize them, teaching them how to be sled dogs."
    },
    "199": {
        "startTime": 1171.9,
        "endTime": 1174.5,
        "transcript": "Kiituan wangkucicetun elitut tua-i.",
        "translation": "Eventually, they learn like we do."
    },
    "200": {
        "startTime": 1175.0,
        "endTime": 1179.0,
        "transcript": "Cayaraq nalluvkenaku, ayagyararteng-llu nalluvkenaku,",
        "translation": "They know how to do things, know where to go,"
    },
    "201": {
        "startTime": 1179.5,
        "endTime": 1183.0,
        "transcript": "Arulairyararteng-llu pissuuteturramta nalluvkenaku.",
        "translation": "And they know where to stop to take us to our hunting grounds."
    },
    "202": {
        "startTime": 1184.0,
        "endTime": 1187.0,
        "transcript": "Tua-i waten pitalua qanqertua.",
        "translation": "This is all I'm going to say."
    },
    "203": {
        "startTime": 1188.0,
        "endTime": 1193.0,
        "transcript": "Akngirqenglliniuq wall'u tuqucilliniuq.",
        "translation": "It apparently hurt or killed someone."
    },
    "204": {
        "startTime": 1194.0,
        "endTime": 1199.5,
        "transcript": "Avani tan'gaurlullraullemni tamakunek niiteksaitellruyaaqua.",
        "translation": "Back when I was a boy, I never heard about those."
    },
    "205": {
        "startTime": 1200.0,
        "endTime": 1204.0,
        "transcript": "Tau͡gaam maa-i tamana maa-i niitelangarput.",
        "translation": "But we have started hearing about that now."
    },
    "206": {
        "startTime": 1204.5,
        "endTime": 1211.5,
        "transcript": "Cali-llu pavani im' ellangartelallruama Akulmi",
        "translation": "And because I have my earliest memories inland in the Akula region"
    },
    "207": {
        "startTime": 1212.5,
        "endTime": 1216.0,
        "transcript": "Cali makut qimugtet piciatun ayagayuitellruut.",
        "translation": "These dogs didn't wander anywhere either."
    },
    "208": {
        "startTime": 1216.1,
        "endTime": 1218.0,
        "transcript": "Pikestaita petuumatullruit.",
        "translation": "Their owners kept them leashed."
    },
    "209": {
        "startTime": 1218.8,
        "endTime": 1226.5,
        "transcript": "Cali-llu qanruquratuluta ullagavkenaki qimugtet pilaasqevkenaki kegciqniluta.",
        "translation": "Also, they always told us not to go near dogs because they will bite us."
    },
    "210": {
        "startTime": 1227.5,
        "endTime": 1231.5,
        "transcript": "Tamana tamaa-i cali wangkuta apa'urluurtellriani",
        "translation": "We who have become grandfathers"
    },
    "211": {
        "startTime": 1232.5,
        "endTime": 1239.5,
        "transcript": "Tamana cali makunun tutgaramteńun cali qanruyutekarput.",
        "translation": "We pass that wisdom on to our grandchildren."
    },
    "212": {
        "startTime": 1240.5,
        "endTime": 1244.0,
        "transcript": "Makut qimugtet ayuqenritliniut.",
        "translation": "These dogs are apparently all different."
    },
    "213": {
        "startTime": 1244.1,
        "endTime": 1249.5,
        "transcript": "Ilait ilaliunqeggluteng, ilait-llu wangtun qenngaluteng.",
        "translation": "Some are friendly, and some are easily angered like me."
    },
    "214": {
        "startTime": 1250.0,
        "endTime": 1255.5,
        "transcript": "Tamana tamaa-i cali umyuaqnaqluni,",
        "translation": "We must also remember that,"
    },
    "215": {
        "startTime": 1255.6,
        "endTime": 1262.5,
        "transcript": "Cali-llu elicungcautekluku pinaqluku makunun tutgaramteńun.",
        "translation": "And we must teach it to our grandchildren here."
    },
    "216": {
        "startTime": 1262.6,
        "endTime": 1266.9,
        "transcript": "Tutgarama kankut qimulleraanka paqtailarait",
        "translation": "My grandchildren go to see my dogs down there"
    },
    "217": {
        "startTime": 1267.0,
        "endTime": 1271.5,
        "transcript": "Tau͡gaam inerqualaranka pivallagavkenaki.",
        "translation": "But I admonish them against treating them excessively."
    },
    "218": {
        "startTime": 1271.9,
        "endTime": 1275.0,
        "transcript": "Cali-llu qaillukuarpek'naki pilaasqelluki.",
        "translation": "I also tell them not to bother them."
    },
    "219": {
        "startTime": 1276.0,
        "endTime": 1279.5,
        "transcript": "Wii murilkelaranka makut waten qanruyutengqerrata:",
        "translation": "I watch over them because they have this traditional wisdom:"
    },
    "220": {
        "startTime": 1279.6,
        "endTime": 1285.0,
        "transcript": "Una-gguq qimugta piyuilngalnge'rmi ilani piaqata",
        "translation": "Even when this dog doesn't seem like the type, when the others do"
    },
    "221": {
        "startTime": 1286.5,
        "endTime": 1289.0,
        "transcript": "Ilani ilagarluki tuaten yuliutuuq.",
        "translation": "It attacks people along with the others."
    },
    "222": {
        "startTime": 1289.5,
        "endTime": 1293.0,
        "transcript": "Tamana tamaa-i amllermek ilasciigataqa.",
        "translation": "I cannot add a lot to that."
    },
    "223": {
        "startTime": 1293.5,
        "endTime": 1301.0,
        "transcript": "Tau͡gaam wani taqnguaqerarkauluci igausngaamci 2:30-qan.",
        "translation": "But now, I have youpl tentatively written down to stop at 2:30."
    },
    "224": {
        "startTime": 1301.5,
        "endTime": 1305.0,
        "transcript": "Three kela'agmi tau͡gaam ukut utaqaciqaput.",
        "translation": "But we will wait for three o'clock for them."
    },
    "225": {
        "startTime": 1305.5,
        "endTime": 1313.9,
        "transcript": "Three kela'akan mat'um nerangnaqurallemta tungiinun qanrarkat.",
        "translation": "At three o'clock, they will speak about subsistence."
    },
    "226": {
        "startTime": 1314.0,
        "endTime": 1318.0,
        "transcript": "Wani break-arciquci.",
        "translation": "Youpl will take a break now."
    }
};